import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledProfileCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;
`;

export const StyledProfileIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 14%) 0px 2px 2px 1px;
  background-color: transparent;
  padding: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  cursor: pointer;

}
`;

export const StyledMobileWrapper = styled.div`
  @media ${MEDIA_QUERIES.MOBILE} {
    margin-top: -3.5rem;
    padding: 25px 0 5px 0;
  }
`;
